import { render, staticRenderFns } from "./MySpaceQuestions.vue?vue&type=template&id=5b522e26&"
import script from "./MySpaceQuestions.vue?vue&type=script&lang=js&"
export * from "./MySpaceQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports